import * as stylex from "@stylexjs/stylex";
import { Link, useRouter } from "@tanstack/react-router";

import { FoodsBrowserConnected } from "@animus/dom-features";
import {
  useAuthStatus,
  useAuthStore,
} from "@animus/frontend-features/auth-store";

import { badge, button, layout, page, spacing, text } from "../styles.stylex";

export function Home() {
  const router = useRouter();
  const status = useAuthStatus();
  const authLoading = useAuthStore(
    (s) => s.isInitializing || s.isAuthenticating
  );
  const user = useAuthStore((s) => s.user);
  const signOut = useAuthStore((s) => s.signOut);

  // Anonymous users should appear as "logged out" in UI
  const isLoggedIn = status === "authenticated" && !user?.isAnonymous;

  const isAdminOrMod = user?.role === "admin" || user?.role === "moderator";

  async function handleSignOut() {
    await signOut();
    router.invalidate();
  }

  return (
    <div {...stylex.props(layout.centeredColumn, page.dark)}>
      <h1 {...stylex.props(spacing.mb4, text.bold, text["4xl"])}>Animus</h1>

      {/* Auth status */}
      <div {...stylex.props(spacing.mb6, layout.flexRow, layout.gap4)}>
        {authLoading && <span {...stylex.props(text.muted)}>Loading...</span>}
        {!authLoading && isLoggedIn && (
          <>
            <span {...stylex.props(text.muted)}>
              {user?.email}
              <span {...stylex.props(badge.base, badge.neutral, spacing.ml2)}>
                {user?.role}
              </span>
            </span>
            {isAdminOrMod && (
              <Link
                {...stylex.props(button.base, button.primary, button.small)}
                to="/admin"
              >
                Admin Panel
              </Link>
            )}
            <button
              {...stylex.props(button.base, button.secondary, button.small)}
              onClick={handleSignOut}
              type="button"
            >
              Sign Out
            </button>
          </>
        )}
        {!(authLoading || isLoggedIn) && (
          <>
            <Link
              {...stylex.props(button.base, button.primary, button.small)}
              to="/login"
            >
              Sign In
            </Link>
            <Link
              {...stylex.props(button.base, button.secondary, button.small)}
              to="/signup"
            >
              Sign Up
            </Link>
          </>
        )}
      </div>

      {/* Foods browser */}
      <div {...stylex.props(spacing.mt8, styles.foodsContainer)}>
        <FoodsBrowserConnected />
      </div>
    </div>
  );
}

const styles = stylex.create({
  foodsContainer: {
    width: "100%",
    maxWidth: 900,
  },
});
